import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/icon_serve.png';
const _withScopeId = n => (_pushScopeId("data-v-38b6134a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pageContainer" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "shareBtn icon-share-black" }, null, -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "iconBox icon-serve" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "icon-serve",
        src: _imports_0,
        alt: ""
    })
], -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, "咨询", -1));
const _hoisted_8 = [
    _hoisted_6,
    _hoisted_7
];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "price" };
import { hostPath } from '@utils/basePath';
import PayTip from '@/components/common/payTip.vue';
import Footer from '@/components/common/Footer.vue';
import Header from '@com/common/Header.vue';
import { ref, onMounted, computed, getCurrentInstance, onUnmounted } from 'vue';
import { Toast } from 'vant';
import { getExerciseGuide, getExerciseOrderInfo, createExerciseOrder } from '@/api/meeting';
import { callPhone, appPort, iOSPort, getUserId, userLogin, mobileApi, weixinShare, hiddenAppNavBar, wechatPort, appShare, applePay, isLogin, PCPort, versionCompare } from '@/widget/index';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $showLoading, $router, $hideLoading, $store } } = getCurrentInstance();
        const isApp = ref(appPort());
        const iOS = ref(iOSPort());
        const isPc = ref(PCPort());
        const currentRoute = $router.currentRoute;
        const showHeader = !appPort() || versionCompare('6.0.1');
        let depId = currentRoute.value.query.depId || '';
        const detail = ref({ isPay: false, applePayId: '', id: 2 });
        const loaded = ref(true);
        const userId = getUserId();
        const shareInfo = ref({
            title: '',
            desc: '',
            url: '',
            image: ''
        });
        // 获取导览页数据
        const getGuide = () => {
            $showLoading();
            $store.commit('SET_PAYTIP', false);
            getExerciseGuide({
                userId: userId
            }, {
                depId: depId
            }).then(res => {
                $hideLoading();
                loaded.value = true;
                hiddenAppNavBar();
                if (res.code === 200) {
                    detail.value = res.data;
                    let share = res.data.share || '';
                    shareInfo.value = share;
                    depId = res.data.depId;
                    if (!wechatPort()) {
                        share &&
                            weixinShare({
                                title: share.title,
                                url: share.url,
                                desc: share.desc,
                                image: share.image
                            });
                    }
                }
                else {
                    Toast(res.message);
                }
            });
        };
        // 创建订单
        const sourceId = currentRoute.value.query.sourceId || '0';
        const apply = () => {
            if (isLogin) {
                if (iOS.value && isApp.value) {
                    applePay({
                        type: 'exercise',
                        exerciseId: detail.value.id,
                        applePayId: detail.value.applePayId
                    });
                    return;
                }
                $showLoading();
                createExerciseOrder({
                    userId: userId
                }, {
                    depId: depId,
                    sourceId: sourceId
                }).then(res => {
                    if (res.code === 200) {
                        // 获取订单信息
                        getOrderInfo(res.data);
                    }
                    else {
                        $hideLoading();
                        Toast(res.message);
                    }
                });
            }
            else {
                userLogin();
            }
        };
        // 获取病例练习订单数据
        const orderInfo = ref({});
        const getOrderInfo = (id) => {
            getExerciseOrderInfo({
                orderId: id
            }).then(res => {
                $hideLoading();
                if (res.code === 200) {
                    $store.commit('SET_PAYTIP', true);
                    orderInfo.value = res.data;
                }
                else {
                    Toast(res.message);
                }
            });
        };
        // 拨打电话
        const service = (tel) => {
            callPhone(tel);
        };
        const btnText = computed(() => {
            return detail.value.isPay ? '立即续费' : '立即开通';
        });
        // 返回
        const backFn = () => {
            if (isApp.value) {
                const data = { type: 'webViewBack' };
                mobileApi(data);
            }
            else {
                // 推荐跳转 / 活动页面跳转
                if (currentRoute.value.query.sourceInfo) {
                    const backUrl = window.decodeURIComponent(currentRoute.value.query.backUrl);
                    location.href = `${hostPath}${backUrl}`;
                }
                else {
                    $router.push({
                        name: 'medicaseHome',
                        query: {
                            depId: depId
                        }
                    });
                }
            }
        };
        // app 分享
        const shareFn = () => {
            appShare(shareInfo.value);
        };
        // 支付成功回调
        const payCallBack = () => {
            $router.replace({
                name: 'medicaseHome',
                query: {
                    depId: depId
                }
            });
        };
        onMounted(() => {
            globalThis.currentPageUpdate = () => {
                getGuide();
            };
            getGuide();
        });
        onUnmounted(() => {
            if (globalThis.currentPageUpdate) {
                delete globalThis.currentPageUpdate;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("div", null, [
                    (!isPc.value && _unref(showHeader))
                        ? (_openBlock(), _createBlock(Header, {
                            key: 0,
                            pageTitle: '病例练习会员',
                            onBackFn: backFn,
                            showBack: true
                        }, {
                            shareBtn: _withCtx(() => [
                                (isApp.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "shareWrapper",
                                        onClick: _withModifiers(shareFn, ["stop"])
                                    }, _hoisted_4, 8, _hoisted_2))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "content",
                        innerHTML: detail.value.htmlContent
                    }, null, 8, _hoisted_5),
                    _createVNode(Footer, { class: "no-padding" }, {
                        apply: _withCtx(() => [
                            (detail.value.isConsult)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "serve",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (service(detail.value.consultingTelephone)), ["stop"]))
                                }, _hoisted_8))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", {
                                class: "btn",
                                onClick: _withModifiers(apply, ["stop"])
                            }, [
                                _createElementVNode("p", null, _toDisplayString(_unref(btnText)), 1),
                                _createElementVNode("p", _hoisted_10, _toDisplayString(iOS.value && isApp.value ? detail.value.applePayPrice : detail.value.price) + " 元/年 ", 1)
                            ], 8, _hoisted_9)
                        ]),
                        _: 1
                    })
                ], 512), [
                    [_vShow, loaded.value]
                ]),
                _withDirectives(_createVNode(PayTip, {
                    module: 'exercise',
                    orderInfo: orderInfo.value,
                    onPayCallBack: payCallBack
                }, null, 8, ["orderInfo"]), [
                    [_vShow, _unref($store).state.payTip]
                ])
            ]));
        };
    }
});
